<template>
  <v-app>
    <v-app-bar app color="primary" dark elevation="0">
      <v-app-bar-nav-icon @click.stop="mini = !mini"></v-app-bar-nav-icon>
      <v-toolbar-title>Dashboard</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu bottom min-width="200px" rounded offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon x-large v-on="on">
            <v-avatar color="brown" size="48">
              <img
                v-if="user.image"
                :alt="user.User.substring(0, 2)"
                :src="'data:image/jpeg;base64,' + user.image"
              />
              <span v-if="user.image == null">{{
                user.User.substring(0, 2)
              }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list-item-content class="justify-center">
            <div class="mx-auto text-center">
              <v-avatar color="brown">
                <img
                  v-if="user.image"
                  :alt="user.User.substring(0, 2)"
                  :src="'data:image/jpeg;base64,' + user.image"
                />
                <span v-if="user.image == null">{{
                  user.User.substring(0, 2)
                }}</span>
              </v-avatar>
              <h3>{{ user.UserFullName | toupper }}</h3>
              <p class="caption mt-1">
                {{ role }}
              </p>
              <v-divider class="my-3"></v-divider>
              <v-btn depressed rounded text> Edit Account </v-btn>
              <v-divider class="my-3"></v-divider>
              <v-btn @click="Logout" depressed rounded text> Logout </v-btn>
            </div>
          </v-list-item-content>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="mini"
      permanent
      app
      floating
    >
      <v-list-item>
        <v-icon>mdi-account</v-icon>
        <v-list-item-content>
          <v-list-item-title class="title"> Admin </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.href"
        >
          <v-list-item-icon>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="primary--text">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
      <template v-slot:append>
        <v-list-item @click="toggleTheme"
          ><v-list-item-icon>
            <v-icon color="primary" v-html="buttonIcon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="primary--text">{{
              buttonText
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>
    <v-main>
      <v-container class="px-4 py-0 fill-height" fluid>
        <v-row class="fill-height">
          <v-col>
            <transition name="fade">
              <router-view @change="console.clear()"></router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { Decrypt, Encrypt } from "../../../lib/encryption";

export default {
  data() {
    return {
      overlay: false,

      user: {
        User: "",
        UserFullName: "",
        image: "",
        isActive: false,
        isAdmin: false,
        isRep: false,
        message: "",
        success: false,
        token: "",
      },
      drawer: true,
      mini: true,
      sidebarMenu: true,
      toggleMini: false,
      items: [
      //  { title: "Home", href: "/", icon: "mdi mdi-home" },
      //  { title: "Orders", href: "/orders", icon: "mdi mdi-truck" },
        { title: "Products", href: "/products", icon: "mdi mdi-store" },
     //   { title: "Customers", href: "/cust", icon: "mdi mdi-bowling" },
     //   { title: "Outstandings", href: "/outs", icon: "mdi mdi-account-arrow-left" },

   //     { title: "Users", href: "/users", icon: "mdi mdi-account" },
     //   { title: "Reps", href: "/rep", icon: "mdi mdi-account" },
        { title: "Settings", href: "/settings", icon: "mdi mdi-cog" },
      ],
    };
  },
  components: {},
  filters: {
    toupper(v) {
      return v.toUpperCase();
    },
  },
  computed: {
    role() {
      return this.user.isAdmin ? "Admin" : "";
    },

    buttonIcon() {
      return !this.$vuetify.theme.dark
        ? "mdi mdi-checkbox-blank-circle"
        : "mdi mdi-checkbox-blank-circle-outline";
    },
    buttonText() {
      return this.$vuetify.theme.dark ? "Switch to Light" : "Switch to Dark";
    },
  },
  methods: {
    Logout() {
      this.$router.push("/Login");
    },
    toggleTheme() {
      localStorage.isdark = Encrypt(JSON.stringify(!this.$vuetify.theme.dark));
      this.$vuetify.theme.dark = JSON.parse(Decrypt(localStorage.isdark));
    },
  },
  beforeCreate() {
    if (!localStorage.user) {
      this.$router.push("/login");
    }
  },
  mounted() {},
  beforeMount() {
    this.user = JSON.parse(Decrypt(localStorage.user));
    this.$vuetify.theme.dark = JSON.parse(Decrypt(localStorage.isdark));

    /*  console.log(this.user);

    if (!localStorage.user) {
      this.$router.push("/login");
    } else {
      console.log(JSON.parse(Decrypt(localStorage.user)));
      this.user = JSON.parse(Decrypt(localStorage.user));
    }*/
  },
};
</script>


<style>
.tbtn {
  cursor: pointer;
}
.daynight {
  padding: 0 16px;
}
.daynight:hover {
  background-color: #fff;
}
</style>